import "./utils/install-network-guard";
import React from "react";
import ReactDOM from "react-dom/client";
import { ReactQueryProvider } from "./context/ReactQueryProvider";
import { RouterProvider } from "react-router-dom";
import * as Sentry from "@sentry/react";
import RootLayout from "./app/layouts/RootLayout";
import { router } from "./app/routes";
import { sentryBeforeSend } from "./utils/sentry-before-send";
import "./app/global.css";

console.log("🚀 main.tsx: Starting app initialization...");

// Initialize Sentry
console.log("🔧 main.tsx: Initializing Sentry...");
if (import.meta.env.VITE_SENTRY_DSN) {
  try {
    Sentry.init({
      dsn: import.meta.env.VITE_SENTRY_DSN,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
          maskAllText: true,
          blockAllMedia: true,
        }),
        // React Router v6 integration for tracking route changes
        // Note: reactRouterV6BrowserTracingIntegration is automatically included in browserTracingIntegration
        // No need to add it separately
      ],
      tracesSampleRate: 1.0,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      debug: false,
      environment: import.meta.env.MODE || "development",
      beforeSend: sentryBeforeSend,
    });
    console.log("✅ main.tsx: Sentry initialized successfully");
  } catch (error) {
    console.error("❌ main.tsx: Sentry initialization failed:", error);
  }
} else {
  console.log("⚠️ main.tsx: VITE_SENTRY_DSN not set, skipping Sentry");
}

console.log("🎯 main.tsx: Getting root element...");
const rootElement = document.getElementById("root");
console.log("🎯 main.tsx: Root element:", rootElement);

if (rootElement !== null) {
  console.log("✅ main.tsx: Root element found, creating React root...");
  try {
    const root = ReactDOM.createRoot(rootElement);
    console.log("✅ main.tsx: React root created, rendering app...");

    root.render(
      <React.StrictMode>
        <ReactQueryProvider>
          <RootLayout>
            <RouterProvider router={router} />
          </RootLayout>
        </ReactQueryProvider>
      </React.StrictMode>
    );
    console.log("✅ main.tsx: App rendered successfully!");
  } catch (error) {
    console.error("❌ main.tsx: Failed to render app:", error);
    rootElement.innerHTML = `
      <div style="padding: 20px; font-family: sans-serif;">
        <h1>Application Error</h1>
        <p>Failed to render the application. Please check the console for details.</p>
        <pre>${error instanceof Error ? error.message : String(error)}</pre>
      </div>
    `;
  }
} else {
  console.error("❌ main.tsx: Root element not found!");
}
